import { Sidebar } from '@/components/Sidebar';

export const PageLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen bg-[#F9F8F6]">
      <Sidebar />
      <main className="flex-1 min-w-0 pt-16 pb-20 px-4 sm:px-6 lg:pt-8 lg:pb-8 lg:px-8">
        {children}
      </main>
    </div>
  );
};
